import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import useFundsStateStore from '../../common/funds-state-hook';

const StyledButton = withStyles(() => ({
  root: {
    height: 40,
    width: 40,
    minWidth: 'unset',
    border: '1px solid #8EA3B5',
    padding: '0 0 0 13px',
    marginRight: 8,

    '&.active': {
      border: '1px solid #627484',
      backgroundColor: '#EFF1F6',
    },
  },
  iconSizeMedium: {
    '& > .icon-lw': {
      color: '#19202d',
      fontSize: 18,
      fontWeight: 600,
    },
  },
}))(Button);

export default function NameFilterButton() {
  const set = useFundsStateStore(state => state.set);
  const showNameFilter = useFundsStateStore(state => state.showNameFilter);

  const toggleShowNameFilter = e => {
    e && e.preventDefault();

    set(state => {
      state.showNameFilter = !showNameFilter;
    });
  };

  const className = showNameFilter ? 'active' : '';

  return (
    <StyledButton
      className={className}
      disableRipple
      startIcon={<i className="icon-lw icon-lw-magnifying-glass" />}
      onClick={toggleShowNameFilter}
    />
  );
}
